import React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {GlobalConstants} from "../../globals/GlobalConstants";
import '../../styles/ReinsUpdater.css'
import {fetchAuthSession} from "aws-amplify/auth";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import {refreshToken} from "../../globals/GlobalFunctions";


//axios.defaults.headers.common['Authorization'] = `Bearer ${}`;

function ReinsUpdater() {
    const [currentMethod, setCurrentMethod] = React.useState({reimburse_Method: "0",
        vbasoftware_database: "CoastalAdmin"});
    const [currentDB, setCurrentDB] = React.useState("CoastalAdmin");
    const [validationError, setValidationError] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);

    const onReimburseChange = React.useCallback((e: any, newValue: any) => setCurrentMethod((prev: any) =>
        ({ ...prev, reimburse_Method: newValue.id })), []);

    const handleValidationClose = () => {
        setValidationError(false);
    }

    let token = localStorage.getItem('jwt');
    //console.log('jwt', token);

    const updateContracts = async () => {
        setLoading(true);
        refreshToken();
        currentMethod.vbasoftware_database = currentDB;
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'reinscontract/updatecontracts',
                    currentMethod,
                    {headers: {'Authorization': `Bearer ${token}`}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                }).catch((error) => {
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                });
    }

    return (
        <div className="pageWrapReins">
            <div className="reinsReportCard">
                <span className="reinsLabel">
                    Update To:
                </span>
                <div className="inputWrapperReins">
                    <Autocomplete
                        className="contractSelect"
                        size={"small"}
                        disablePortal
                        disableClearable
                        options={GlobalConstants.ReinsuranceContractReimburseMethods}
                        value={GlobalConstants.ReinsuranceContractReimburseMethods.find(option => option.id === currentMethod.reimburse_Method) || null}
                        defaultValue={GlobalConstants.ReinsuranceContractReimburseMethods[0]}
                        renderInput={(params) => <TextField {...params}  />}
                        onChange={onReimburseChange}
                    />
                </div>
                <div className="buttonWrapper">
                    <Stack spacing={3} direction="row">
                    {/*<Button variant="contained" onClick={getUsers}>Get Users</Button>*/}
                        <LoadingButton className="buttonz" variant="contained" onClick={updateContracts}loading={loading} loadingPosition="start"
                                   startIcon={<SaveIcon />}>Update Current Contracts</LoadingButton>
                    </Stack>
                </div>
                <Dialog
                    open={validationError}
                    onClose={handleValidationClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {"Validation Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {validationText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleValidationClose}>OK</Button>
                    </DialogActions>
                </Dialog>
                {successAlert ? <Alert className="reinsAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                    <AlertTitle>Success!</AlertTitle>
                    Contract Update Successful!
                </Alert> : <></> }
            </div>
            <Stack spacing={5} direction="row" className="buttonBarReins">
                <Autocomplete
                    className="dbContractSelectReins"
                    size={"small"}
                    disablePortal
                    disableClearable
                    options={GlobalConstants.VBA_DB}
                    value={GlobalConstants.VBA_DB.find(option => option.id === currentDB) || null}
                    sx={{ width: 150 }}
                    defaultValue={GlobalConstants.VBA_DB[1]}
                    renderInput={(params) => <TextField {...params}  />}
                    onChange={onDBChange}
                />
            </Stack>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default React.memo(ReinsUpdater);